import { FC } from 'react';
import { Link } from 'react-router';

export const LegalLinks: FC = () => (
    <div className="flex flex-wrap justify-between gap-x-3 gap-y-1">
        <Link
            className="text-xs text-(--mantine-color-text-5) hover:text-(--mantine-color-text-7) underline"
            to={'https://www.2rsoftware.de/impressum/'}
            target="_blank"
        >
            Impressum
        </Link>
        <Link
            className="text-xs text-(--mantine-color-text-5) hover:text-(--mantine-color-text-7) underline"
            to={'/datenschutzerklaerung.pdf'}
            target="_blank"
        >
            Datenschutzerklärung
        </Link>
        <Link
            className="text-xs text-(--mantine-color-text-5) hover:text-(--mantine-color-text-7) underline"
            to={'/THIRD_PARTY_LICENSES.md'}
            target="_blank"
        >
            Credits
        </Link>
    </div>
);
